import { motion } from "framer-motion";
import { useLang } from "../../i18n";
import { Reveal, EASE } from "./Reveal";

export function Manifesto() {
  const { t } = useLang();
  const titleLines = t.manifesto.title.split("\n");

  return (
    <section id="story" className="relative py-28 md:py-40 bg-[var(--bg-2)]">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Reveal className="mb-16 md:mb-24">
          <p className="eyebrow mb-6">{t.manifesto.eyebrow}</p>
          <h2 className="font-display font-light text-4xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight max-w-4xl">
            {titleLines.map((l, i) => (
              <span key={i} className="block">{l}</span>
            ))}
          </h2>
        </Reveal>

        <div className="space-y-0">
          {t.manifesto.chapters.map((ch, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, ease: EASE }}
              className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-10 md:py-14 border-t border-[var(--ink)]/10 items-center"
            >
              <div className="md:col-span-3">
                <span className="font-display text-6xl md:text-8xl leading-none text-[var(--gold)]/35">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <p className="md:col-span-8 md:col-start-5 font-display text-2xl md:text-4xl leading-snug text-[var(--ink)] font-light">
                {ch}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
